module.exports = __webpack_public_path__ + "static/media/dk2069.b48f1836.png";